<template>
  <div class="history-main">
    <div class="history-title">
      <div class="icon">
        <img src="../../assets/image/yuantu.png" />
        <!-- {{lan.c_cochat}} -->
      </div>
      <div class="tab">
        <span :class="login.tab =='rong'? 'active rong':'rong'" @click="ronghistory">{{lan.c_rong}}</span>
        <span :class="login.tab =='guang'? 'active':''" @click="guanghistory">{{lan.c_ji}}</span>
      </div>
      <div class="user">
        <HeadURL :itcode="login.userInfo.itcode" class="headurl" />
        <span class="language" @click="changeEn" v-show="lanType">English</span>
        <span class="language" @click="changeCn" v-show="!lanType">中文</span>
        <span class="backlogin" @click="backlogin">{{lan.c_logout}}</span>
      </div>
    </div>
    <div class="downopen" v-show="rong.downfinish || guang.downfinish">{{lan.c_downfinish}}!</div>
    <div class="timewarning" v-show="rong.timeShow || guang.timeShow">
      {{lan.c_time}}
    </div>
    <Rong v-show="login.tab =='rong'"></Rong>
    <Guang v-show="login.tab =='guang'"></Guang>
  </div>
</template>
<script>
import Guang from "../guang/index";
import Rong from "../rong/index";
import { mapState, mapMutations, mapGetters } from "vuex";
import HeadURL from "../headurl/index";
import router from "../../router/index";
export default {
  name: "history",
  data() {
    return {
      lanType: true
    };
  },
  computed: {
    ...mapState(["login", "rong", "guang"]),
    ...mapGetters({ lan: "common/lan" })
  },
  methods: {
    ...mapMutations({
      getPersonList: "guang/getPersonList",
      setlanguage: "common/setlanguage"
    }),
    guanghistory() {
      this.login.tab = "guang";
      let params = {
        sessionId: this.login.userInfo.session_id,
        userId: this.login.userInfo.itcode
      };
      this.getPersonList(params);
    },
    ronghistory() {
      this.login.tab = "rong";
    },
    backlogin() {
      router.push("/");
    },
    changeEn() {
      // let pageinput = document.getElementsByClassName("el-pagination__jump");
      // pageinput[0].innerText = this.lan.c_go+this.lan.c_page
      this.lanType = false;
      this.setlanguage("en");
      // locale.use(lang)
    },
    changeCn() {
      this.lanType = true;
      this.setlanguage("cn");
    },
  },
  components: {
    Rong,
    HeadURL,
    Guang
  },
  mounted() {
  }
};
</script>

<style lang="scss" scoped>
.history-main {
  .history-title {
    width: 100%;
    // line-height: 57px;
    display: flex;
    padding: 18px 35px 0 70px;
    // align-items: center;
    justify-content: space-between;
    box-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);
    .icon {
      // font-size: 17px;
      // font-family: PingFangSC;
      // color: rgba(37, 182, 237, 1);
      // display: flex;
      // align-items: center;
      // padding-bottom: 18px;
      // vertical-align:middle;
      // width: 100px;
      // display: inline-block;
      img {
        width: 131px;
        height: 42px;
      }
    }
    .tab {
      font-size: 14px;
      font-family: PingFangSC;
      color: rgba(74, 74, 74, 1);
      display: flex;
      padding-right: 270px;
      // box-sizing: border-box;
      // padding-bottom: 18px;
      // display: inline-block;
      // height: 30px;
      padding-top: 6px;
      span {
        cursor: pointer;
      }
      .active {
        display: inline-block;
        // width: 110px;
        text-align: center;
        // margin-right: 53px;
        border-bottom: 2px solid rgba(37, 182, 237, 1);
        // padding-bottom: 38px;
      }
      .rong {
        // display: inline-block;
        // width:116px;
        margin-right: 53px;
      }
    }
    .user {
      display: flex;
      // display: inline-block;
      // line-height: 28px;
      align-items: center;
      padding-bottom: 18px;
      .headurl {
        width: 32px;
        height: 32px;
        border-radius: 3px;
        margin-right: 20px;
        margin-top: 5px;
        display: inline-block;
      }
      .language {
        cursor: pointer;
        display: inline-block;
        width: 71px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        border-radius: 4px;
        border: 1px solid rgba(151, 151, 151, 1);
        font-size: 14px;
        font-family: PingFangSC;
        color: rgba(74, 74, 74, 1);
      }
      .language:hover {
        color: #25b6ed;
        border: 1px solid #25b6ed;
      }
      .backlogin {
        cursor: pointer;
        margin-left: 17px;
        font-size: 13px;
        font-family: PingFangSC;
        color: rgba(74, 74, 74, 1);
        width: 71px;
        text-align: center;
        height: 28px;
        line-height: 28px;
        border-radius: 4px;
        border: 1px solid rgba(151, 151, 151, 1);
      }
      .backlogin:hover {
        color: #25b6ed;
        border: 1px solid #25b6ed;
      }
    }
  }
  .downopen {
    position: fixed;
    top: 73px;
    left: 0;
    text-align: center;
    width: 100%;
    height: 32px;
    font-size: 14px;
    font-family: PingFangSC;
    color: rgba(25, 130, 170, 1);
    line-height: 32px;
    background: rgba(37, 182, 237, 0.3);
    border-radius: 4px;
  }
  .timewarning {
    position: fixed;
    top: 73px;
    left: 0;
    text-align: center;
    width: 100%;
    height: 32px;
    font-size: 14px;
    font-family: PingFangSC;
    color: rgba(182, 29, 48, 1);
    line-height: 32px;
    background: rgba(227, 37, 38, 0.3);
    border-radius: 4px;
    span {
      margin-left: 10px;
      cursor: pointer;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/history/index.vue